import React, { useState, useEffect } from 'react';
import { groupsAPI } from '../../services/api';
import './GroupSelectionModal.css';

function GroupSelectionModal({ memberId, onClose, onSelect, selectedGroups = [] }) {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selected, setSelected] = useState(new Set(selectedGroups));

    useEffect(() => {
        fetchGroups();
    }, [memberId]);

    // Update selected groups when prop changes
    useEffect(() => {
        setSelected(new Set(selectedGroups));
    }, [selectedGroups]);

    const fetchGroups = async () => {
        try {
            const response = await groupsAPI.getAllGroups();
            const groups = Array.isArray(response) ? response : [];
            setGroups(groups);
        } catch (error) {
            setError(error.message || 'Failed to fetch groups');
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const toggleGroupSelection = (groupId) => {
        const newSelected = new Set(selected);
        if (newSelected.has(groupId)) {
            newSelected.delete(groupId);
        } else {
            newSelected.add(groupId);
        }
        setSelected(newSelected);
    };

    const handleSubmit = () => {
        const selectedGroupsArray = Array.from(selected);
        onSelect(selectedGroupsArray);
        onClose();
    };

    const filteredGroups = groups.filter(group =>
        group.name.toLowerCase().includes(searchQuery)
    );

    if (loading) return <div className="modal">Loading...</div>;
    if (error) return <div className="modal">Error: {error}</div>;

    return (
        <div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <h2>Select Groups</h2>
                    <div className="selected-count">
                        Selected: {selected.size} groups
                    </div>
                    <input
                        type="text"
                        placeholder="Search groups..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
                <div className="groups-list">
                    {filteredGroups.length > 0 ? (
                        filteredGroups.map(group => (
                            <div
                                key={group.id}
                                className={`group-item ${selected.has(group.id) ? 'selected' : ''}`}
                                onClick={() => toggleGroupSelection(group.id)}
                            >
                                <span className="group-name">{group.name}</span>
                                <span className="group-type">{group.type}</span>
                            </div>
                        ))
                    ) : (
                        <div className="no-groups-message">
                            {searchQuery ? 'No matching groups found' : 'No groups available'}
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button onClick={handleSubmit}>Confirm</button>
                    <button onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default GroupSelectionModal; 